import { render, staticRenderFns } from "./orderRadio.vue?vue&type=template&id=079c2fe3&scoped=true&"
import script from "./orderRadio.vue?vue&type=script&lang=js&"
export * from "./orderRadio.vue?vue&type=script&lang=js&"
import style0 from "./orderRadio.vue?vue&type=style&index=0&id=079c2fe3&prod&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079c2fe3",
  null
  
)

export default component.exports